import React from 'react'

import logoHyundai from './../../UI/Loading/logo_hyundai.svg'
import logoDesarrollo from './../../UI/Loading/logo_desarrollo.svg'
import bg from './../../UI/Loading/bg.webp'

import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface Props {
  handleOpenScene: () => void,
  openLoadingScreen: boolean,
  currentLoadingPercentage: number,
  currentLoadingInteriorPercentage: number,
  isLocale: boolean
}

interface State {
  currentLoadingPercentage: number
  currentLoadingInteriorPercentage: number
}

class LoadingScreen extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentLoadingPercentage: 0,
      currentLoadingInteriorPercentage: 0
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if(this.props.isLocale !== prevProps.isLocale && this.props.isLocale){
        const loader = setInterval(() => {
          if(this.state.currentLoadingPercentage !== 100){
            this.setState({
              currentLoadingPercentage: this.state.currentLoadingPercentage + 1
            })
          }
          else{
            clearInterval(loader)
            setTimeout(() => {
              //this.props.handleOpenScene()
            }, 2000)
          }
        }, 10)
      }
      if((prevProps.currentLoadingPercentage !== this.props.currentLoadingPercentage || prevProps.currentLoadingInteriorPercentage !== this.props.currentLoadingInteriorPercentage) && this.props.isLocale !== true){
        this.setState({
          currentLoadingPercentage: this.props.currentLoadingPercentage,
          currentLoadingInteriorPercentage: this.props.currentLoadingInteriorPercentage / 2
        }, () => {
          if(this.props.currentLoadingPercentage === 100){
            setTimeout(() => {
              //this.props.handleOpenScene()
            }, 2000)
          }
        })
      }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.openLoadingScreen ? 'loading-container fade-in':'loading-container fade-out'}>
          <div className='loading-background-container'>
            <img src={bg} alt=''/>
          </div>
          <div className='logo-loading-container'>
            <img src={logoHyundai} alt=''/>
          </div>
          <div className='logo-loading-circle-container'>
          < CircularProgressbar background={true} backgroundPadding={6}
          value={this.state.currentLoadingPercentage} 
          text={``} 
          strokeWidth={3}
          styles={buildStyles({
            pathColor: "#05A3E1",
            trailColor: "#EBEDF7",
            backgroundColor: "rgba(0,0,0,0)"
          })}
          />
          </div>
          <div className='logo-desarrollo-container'>
            <img src={logoDesarrollo} alt=''/>
          </div>
        </div>
      )
  }
}

export default LoadingScreen